import React from 'react'
import { motion, AnimatePresence } from 'framer-motion'
import style from './style.module.scss'
import { useScrollDirection } from '../../../hooks/useScrollDirection'
import clsx from 'clsx'

type stickyHeaderProps = React.PropsWithChildren<{
    sticky: boolean
}>

const StickyHeader: React.FC<stickyHeaderProps> = ({ sticky, children }) => {
    const scrollDir = useScrollDirection({ initialDirection: 'up', thresholdPixels: 0 })

    return (
        <AnimatePresence>
            {sticky && (
                <motion.div
                    className={clsx(
                        style.sticky,
                        scrollDir === 'down' ? style.disabled : undefined,
                    )}
                    animate={{
                        top: 0,
                    }}
                    transition={{
                        duration: 0.5,
                        default: { ease: 'linear' },
                    }}
                >
                    {children}
                </motion.div>
            )}
        </AnimatePresence>
    )
}

export default StickyHeader
